'use client';

import React from 'react';

import { Cms } from '@bytel/product-wall';
import { Icon, IconName, IconSize, Link, Text, TextMarkup, TypographyBold, View } from '@bytel/trilogy-react';

import { WallType } from '@app-types/config';
import { ProductChildFull } from '@app-types/product';

import { TabsEnum } from '@product-detail/components';

export type ProductSpecificationsProps = {
    type: WallType;
    product: ProductChildFull;
    specificationsCms?: string;
    setActiveTab: (tab: TabsEnum) => void;
};

export function ProductSpecifications({
    type,
    product,
    setActiveTab,
    specificationsCms,
}: Readonly<ProductSpecificationsProps>) {
    const { characteristics } = product;

    const hasSpecificationsShowed = type === WallType.ACCESSORY || type === WallType.SALES_ACCESSORY;

    const scrollToHighlights = () => {
        setActiveTab(TabsEnum.HIGHLIGHTS);
        setTimeout(() => {
            document.getElementById('highlights-section')?.scrollIntoView({
                behavior: 'smooth',
            });
        }, 0);
    };

    return (
        <>
            {specificationsCms && (
                <>
                    <Cms content={specificationsCms} />
                    <View flexable className='icon-and-text'>
                        <Icon name={IconName.ANONYMOUS_MODE} size={IconSize.MEDIUM} className='is-invisible' />
                        <Link onClick={scrollToHighlights} role='button'>
                            En savoir plus
                        </Link>
                    </View>
                </>
            )}
            {hasSpecificationsShowed && (
                <>
                    {characteristics.material && (
                        <>
                            <Text typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD} marginless>
                                Matière&nbsp;:
                            </Text>
                            <Text>{characteristics.material}</Text>
                        </>
                    )}
                    {characteristics.length && characteristics.width && characteristics.depth && (
                        <>
                            <Text typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD} marginless>
                                Dimensions&nbsp;:
                            </Text>
                            <Text>
                                <Text markup={TextMarkup.SPAN}>{characteristics.length}cm x</Text>
                                <Text markup={TextMarkup.SPAN}>{characteristics.width}cm x</Text>
                                <Text markup={TextMarkup.SPAN}>{characteristics.depth}cm</Text>
                            </Text>
                        </>
                    )}
                    {characteristics.weight && (
                        <>
                            <Text typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD} marginless>
                                Poids net&nbsp;:
                            </Text>
                            <Text>{characteristics.weight}g</Text>
                        </>
                    )}

                    {product.packContent && (
                        <>
                            <Text typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD} marginless>
                                Contenu du pack&nbsp;:
                            </Text>
                            <p dangerouslySetInnerHTML={{ __html: product.packContent }} />
                        </>
                    )}
                </>
            )}
        </>
    );
}
